import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

const categoryBgColors = [
  'bg-accent-100 text-accent-700',
  'bg-primary-100 text-primary-700',
  'bg-secondary-100 text-secondary-700',
  'bg-accent-200/60 text-accent-800',
  'bg-primary-200/60 text-primary-800',
  'bg-secondary-200/60 text-secondary-800',
];

export default function CategorySection() {
  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="site-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            全部分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">探索更多精彩内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full mb-3 transition-transform duration-300 group-hover:scale-110 ${categoryBgColors[index % categoryBgColors.length]}`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-800 font-heading whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 text-center leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}